export const animateCSS = (element, animation,remove, prefix = 'animate__') =>
 
new Promise((resolve, reject) => {
  const animationName = `${prefix}${animation}`;
  const node = document.querySelector(element);

  node.classList.add(`${prefix}animated`, animationName);
 
  function handleAnimationEnd(event) {
    event.stopPropagation();
    if(remove){
      node.classList.remove(`${prefix}animated`, animationName); 
    }
    resolve('Animation ended');
  }

  node.addEventListener('animationend', handleAnimationEnd, {once: true});
});

export const openModalVw = async (id,callback) => { 
  if (callback) callback()
  setTimeout(async () => {
    const modal = document.querySelector(id)
    modal.style.setProperty('opacity', '1')
    const content = document.querySelector(`${id} .modal-content`)
    content.style.setProperty('--animate-duration', '.2s')
    content.style.setProperty('opacity', '1')
    await animateCSS(`${id} .modal-content`, "zoomIn", true)
  }, 100)
}
export const closeModalVw = async (id,callback) => {
  const modal = document.querySelector(id)
  await animateCSS(`${id} .modal-content`, "zoomOut", false)
  modal.style.setProperty('opacity', '0')
  if (callback) callback() 
}

export const openAlert = async (id,callback, closeIn, closeCb) => { 
  if (callback) callback()
  setTimeout(async () => {
    const modal = document.querySelector(id)
    modal.style.setProperty('opacity', '1')
    const content = document.querySelector(`${id}`)
    content.style.setProperty('--animate-duration', '.7s')
    content.style.setProperty('opacity', '1')
    await animateCSS(`${id} .alert-actions`, "bounceIn", true)

    if(closeIn){
      setTimeout(async () => {
        await closeAlert(id,closeCb)
      }, closeIn)
    }
    
  }, 100)
}
export const closeAlert = async (id,callback) => {
  const modal = document.querySelector(id)
  await animateCSS(`${id} .alert-actions`, "bounceOut", false)
  modal.style.setProperty('opacity', '0')
  if (callback) callback() 
 
}